import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const setReminder = async <
  A extends ACTION_TYPE.SET_REMINDER_WEEKLY | ACTION_TYPE.SET_REMINDER_PHARMACY | ACTION_TYPE.SET_REMINDER_PHYSICIAN,
  T extends Action<A>
>({
  uniqueId,
  reminder,
  action
}: Omit<T['payload'], 'timezoneOffset'> & {
  action: A
}): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      uniqueId,
      reminder,
      timezoneOffset: new Date().getTimezoneOffset()
    },
    type: action
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const { reminder: settedReminder } = body.data

  return {
    reminder: settedReminder
  }
}
